import type React from 'react';

interface BlockEditorDrawerProps {
  open: boolean;
  children: React.ReactNode;
}

export function BlockEditorDrawer({ open, children }: BlockEditorDrawerProps) {
  return (
    <div className={`grid transition-[grid-template-rows] duration-200 ease-in-out ${open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
      <div
        className='overflow-hidden'
        {...(!open ? { inert: '' } : {})}
        aria-hidden={!open}
      >
        <div className='flex flex-col gap-3.5 border border-ws-border-strong bg-ws-in-progress-bg/40 px-4 py-3.5'>
          {children}
        </div>
      </div>
    </div>
  );
}
